<app-slim-topbar *ngIf="mobile"></app-slim-topbar>
<div class="flex justify-content-center align-items-center text-xl font-bold" *ngIf="onExtendedMobile() || mobile">
	{{ 'COMPLIANT_DEVICES' | translate }}
</div>
<div class="layout-content p-0 mb-5 mt-3" [ngClass]="layoutMarginResponsive()">
	<form [formGroup]="filterGroup">
		<div class="grid mt-0 px-3">
			<div [class]="col6ResponsiveMainFilter('left')">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'AUTOMATION_CATEGORY' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown [options]="boardClasses" formControlName="type" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-6 surface-900" [showClear]="true"
							id="events-input-deviceFilter" placeholder="{{ 'AUTOMATION_CATEGORY' | translate }}">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.BoardName | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex justify-content-center">
									<div>{{section.BoardName | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div [class]="col6ResponsiveMainFilter('right')">
				<div *ngIf="tabletUnderMinWdCol6() || onExtendedMobile()" class="flex justify-content-between flex-wrap border-bottom-1 border-900"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'SEARCH' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('borderInput')">
						<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
							<i class="pi cm-search"></i>
							<input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
								class="pr-6 surface-900" placeholder="{{ 'SEARCH' | translate }}" maxlength="254" />
						</span>
					</div>
				</div>
				<div *ngIf="!tabletUnderMinWdCol6() && !onExtendedMobile()" class="flex align-items-center justify-content-center"
					[ngClass]="simpleInputTextLayout('borderInput')">
					<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
						<i class="pi cm-search"></i>
						<input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
							class="pr-6 surface-900" id="supportrequest-rbelog-input-search" placeholder="{{ 'SEARCH' | translate }}"
							maxlength="254" />
					</span>
				</div>
			</div>
		</div>
	</form>
	<div class="card mt-3">
			<div class="mt-2">
				<p-table [value]="filterModels" sortField="BoardClass" sortMode="single" dataKey="Id"
					rowGroupMode="subheader" groupRowsBy="SeriesName">
					<ng-template pTemplate="header">
						<tr>
							<th>{{'PRODUCT_NAME' | translate}}</th>
							<th>{{'MOTOR_PRODUCT_CODE' | translate}}</th>
							<th>{{'CONTROL_BOARD' | translate}}</th>
							<th>{{'MAIN_SUPPLY' | translate}}</th>
							<th>{{'MOTOR_VOLTAGE' | translate}}</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="groupheader" let-customer let-rowIndex="rowIndex" let-expanded="expanded">
						<tr>
							<td colspan="12">
								<div class="flex align-items-center justify-content-start gap-3">
									<button type="button" pButton pRipple [pRowToggler]="customer"
										class="p-button-rounded p-button-plain mr-2"
										[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'">
									</button>
									<i class="pi {{getIcon(customer)}} text-4xl text-primary"></i>
									<div>
										<span class="font-bold ml-2">{{getBoardClass(customer)}}</span>
										<span class="font-bold ml-2">{{customer.SeriesName}}</span>
									</div>
								</div>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="rowexpansion" let-customer>
						<tr>
							<td>
								{{customer.ProductName}}
							</td>
							<td>
								{{customer.MotorProductCode}}
							</td>
							<td>
								{{customer.BoardProductName}}
							</td>
							<td>
								{{customer.BoardPower}}
							</td>
							<td>
								{{customer.MotorPower}}
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
	</div>
</div>
<app-common-footer *ngIf="mobile"></app-common-footer>